import { PasswordRecoveryPage } from '@repo/ui';

import { useRequestResetPassword } from '../hooks/useRequestResetPassword';
import { getEnv } from 'shared/get-env';

export const ForgetPasswordPage = () => {
  // hooks
  const { validationSendPasswordResetCode, loadingSendPasswordResetCode } =
    useRequestResetPassword();

  return (
    <PasswordRecoveryPage
      img={getEnv('REACT_APP_URL_LOGO')}
      loading={loadingSendPasswordResetCode}
      validation={validationSendPasswordResetCode}
    />
  );
};
